import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const myVisitorLogList = createAsyncThunk('myVisitor/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'my_visitor_log',
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                created_at: data?.date
                    ? (moment(data.date, 'YYYY-MM-DD', true).isValid()
                        ? data.date
                        : moment(data.date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
                    : undefined,
                user_type: data?.user_type || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const myVisitor = createSlice({
    name: 'myVisitor',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(myVisitorLogList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
    }
})

export default myVisitor.reducer;